








import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GExamCreateConfirmViewValueCell',
  computed: {},
  methods: {},
})
export default class GExamCreateConfirmViewValueCell extends Vue {
  @Prop() dataTestid: string;
  mounted() {}
}
